import './App.css';

import {LoginPage} from "./page/login";
import { createMuiTheme,ThemeProvider } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#ff0000',
            main: '#28aeb1',
            dark: '#ff0000',
            contrastText: '#fff',
        },
        secondary: {
            light: '#00ff00',
            main: '#00ff00',
            dark: '#00ff00',
            contrastText: '#000',
        },
    },
});
function App() {
    return (
        <div >
            <header className="App">
                <ThemeProvider theme={theme}>
                    <LoginPage />
                </ThemeProvider>
            </header>
        </div>
    );
}

export default App;
